import React from "react";
import {Comment} from 'antd';
import PropTypes from "prop-types";
import Day from "./Day";
import {
  AccountIcon,
  DownArrowOutlined,
  HashIcon,
} from '@web/assets/icons';
import UserAvatar from './UserAvatar';

ChatPrompt.propTypes = {
  chat: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  collapsed: PropTypes.bool,
};

export default function ChatPrompt(props) {
  if (!props.chat?.prompt?.text) {
    return null;
  }

  return <div
      className="brainstorm-message right"
      onClick={props.onClick}
      style={{marginBottom: "0"}}
    >
      <div className="space space-center-y gap-30">
        <div
          className={props.chat.prompt.agentId === "ai-assistant" ? 'fat-chip primary font-lg transparent-bg' : 'fat-chip muted font-lg'}
          style={props.chat.prompt.agentId === "ai-assistant" ? {padding: '3px 42px 3px 20px', borderRadius: 80} : {padding: '3px 42px 3px 20px', borderRadius: 80}}
        >
          <Comment
            avatar={<UserAvatar icon={props.chat.prompt.agentId === "ai-assistant" ? <AccountIcon size={36}/> : <HashIcon size={20} className="muted-icon" />} />}
            author={props.chat.prompt.agentId === "ai-assistant" ? "You" : props.chat.prompt.agentId}
            content={
              <div className={`space space-center-y ${props.primary ? 'primary' : 'muted'}`}>
                {props.collapsed && <DownArrowOutlined />}
                {props.chat?.prompt?.text}
                <span
                  className="muted font-sm relative"
                  style={{display: 'inline-block'}}
                >
                <Day ts={props.chat?.prompt?.createdTs} />
              </span>
              </div>}>
          </Comment>
        </div>
      </div>
    </div>
}
